import React, { useState } from "react";
import { theme, Typography, Button as AntButton } from "antd";
import { useTranslate } from "@refinedev/core";
import { PaperclipIcon } from "@phosphor-icons/react";
import { Dropzone } from "../../ContentSidebar.styles";

interface DocumentDropzoneProps {
  /** Called with the dropped files; the parent validates them against the
   *  accepted document types. */
  onFiles: (list: FileList | null) => void;
  /** Open the file picker (shared hidden <input> lives in the parent). */
  onBrowse: () => void;
}

/** Empty-state drop target shown when no documents have been added yet. */
export const DocumentDropzone: React.FC<DocumentDropzoneProps> = ({
  onFiles,
  onBrowse,
}) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const [dragging, setDragging] = useState(false);

  return (
    <Dropzone
      role="button"
      tabIndex={0}
      $token={token}
      $active={dragging}
      onClick={onBrowse}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onBrowse();
        }
      }}
      onDragOver={(e) => {
        e.preventDefault();
        setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        onFiles(e.dataTransfer.files);
      }}
    >
      <PaperclipIcon size={30} />
      <Typography.Text strong style={{ marginTop: 8, fontSize: token.fontSizeLG }}>
        {t("createExperience.addOns.documents.dropzone.title")}
      </Typography.Text>
      <Typography.Paragraph
        type="secondary"
        style={{ maxWidth: 320, marginBottom: 4, lineHeight: 1.45 }}
      >
        {t("createExperience.addOns.documents.dropzone.subtitle")}
      </Typography.Paragraph>
      <AntButton
        icon={<PaperclipIcon size={16} weight="bold" />}
        type="default"
        shape="round"
        style={{ marginTop: 12, height: 30 }}
        onClick={(e) => {
          e.stopPropagation();
          onBrowse();
        }}
      >
        {t("createExperience.addOns.documents.dropzone.browseFiles")}
      </AntButton>
    </Dropzone>
  );
};
